import gql from 'graphql-tag'

/**
 * Query
 */
const ALL_ACTIVE = gql`
    query allCostCenterActive {
        costsCentersActive {
                id
                name
                description
                is_active
                status_text
            }
        }
`

const GET_WITH_PAGINATION = gql`
    query costsCentersWithPagination ($page: Int, $perPage: Int) {
        costsCentersWithPagination (page: $page, first: $perPage) {
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                name
                description
                is_active
                status_text
            }
        }
    }
`

/**
 * Mutations
 */
const CREATE = gql`
    mutation createCostCenter ($input: CreateCostCenterInput!) {
        createCostCenter (input: $input) {
            id
            name
            description
            is_active
            status_text
        }
    }
`

const UPDATE = gql`
    mutation updateCostCenter ($id: ID!, $input: UpdateCostCenterInput!) {
        updateCostCenter (id: $id, input: $input) {
            id
            name
            description
            is_active
            status_text
        }
    }
`

const CHANGE_STATUS = gql`
    mutation updateCostCenter ($id: ID!, $input: UpdateCostCenterInput!) {
        updateCostCenter (id: $id, input: $input) {
            id
            name
            description
            is_active
            status_text
        }
    }
`

const DELETE = gql`
    mutation deleteCostCenter ($id: ID!) {
        deleteCostCenter (id: $id) {
            id
            name
            description
            is_active
            status_text
        }
    }
`

export {
    ALL_ACTIVE,
    GET_WITH_PAGINATION,
    DELETE,
    CHANGE_STATUS,
    CREATE,
    UPDATE
}
